import { ThirdPartyType } from '../../types';
import { apiError } from '../../utils/errors';

interface RenewTokenParams {
  urlSlug: string;
  publicId: string;
  currentToken?: string;
  thirdPartyType?: ThirdPartyType;
}

export const renewToken = async ({
  urlSlug,
  publicId,
  currentToken,
  thirdPartyType,
}: RenewTokenParams): Promise<void> => {
  const baseUrl = `${process.env.REACT_APP_API_URL}/submissions/${urlSlug}/${publicId}/tokens/renew`;
  // if the token is provided, add it to the query string, otherwise the token should get sent via the cookie
  const url = currentToken ? `${baseUrl}?token=${currentToken}` : baseUrl;

  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ thirdPartyType }),
  });

  const responseJson = await response.json();
  if (!response.ok) {
    throw apiError(response.status, responseJson?.message || 'Failed to resend verification email');
  }
};
